import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inicializado: false,
  search: '',
};

export const societarioFiltroSelector = state => state.societarioFiltro;

export const slice = createSlice({
  name: 'societarioFiltro',
  initialState,
  reducers: {
    societarioFiltroResetar: (state) => {
      return { initialState, inicializado: false };
    },
    societarioFiltroAplicar: (state, action) => {
      return { ...state, ...action.payload, inicializado: true, };
    }
  },
  extraReducers: {},
});

export default slice.reducer;

export const { societarioFiltroResetar, societarioFiltroAplicar } = slice.actions;
